<template>
  <div>
    <div class="mb-4">
      <label><b>ĐIỀU 1. SẢN PHẨM/ DỊCH VỤ VÀ THỜI GIAN SỬ DỤNG</b> </label>
      <div class="d-flex ml-2 my-2">
        <span class="mr-2">1.1. </span>
        <span>
          Bên A cung cấp <b>{{ title }}</b> cho Bên B với chính sách như sau:</span
        >
      </div>

      <Loyalty
        v-if="softwarePackage === 'CNV Loyalty' && dataTable"
        :dataTable="dataTable"
      ></Loyalty>
      <Megadoc v-if="softwarePackage === 'Megadoc' && dataTable" :dataTable="dataTable"></Megadoc>
      <MySpa v-if="softwarePackage === 'My Spa' && dataTable" :dataTable="dataTable"></MySpa>
      <NextAcc v-if="softwarePackage === 'NextAcc' && dataTable" :dataTable="dataTable"></NextAcc>
      <NextHR v-if="softwarePackage === 'NextHR' && dataTable" :dataTable="dataTable"></NextHR>
      <NextPhar
        v-if="softwarePackage === 'NextPhar' && dataTable"
        :dataTable="dataTable"
      ></NextPhar>
      <NextShop
        v-if="softwarePackage === 'NextShop' && dataTable"
        :dataTable="dataTable"
      ></NextShop>
      <PosApp v-if="softwarePackage === 'PosApp' && dataTable" :dataTable="dataTable"></PosApp>
      <VInvoice
        v-if="softwarePackage === 'VInvoice' && dataTable"
        :dataTable="dataTable"
      ></VInvoice>
    </div>
    <div class="mb-4">
      <div class="d-flex ml-2 my-2">
        <span class="mr-2">1.2. </span>
        <span>
          Bên B đồng ý sử dụng gói phần mềm {{ softwarePackage }}
          <span v-if="productPackage.namePackage">
            {{ productPackage.namePackage }}
          </span>
          với thời gian sử dụng là
          <span v-if="productPackage">
            <template v-if="productPackage.name === 'Vĩnh Viễn'"> vĩnh viễn </template>
            <template v-else> {{ productPackage.number }} {{ productPackage.name }} </template>
          </span>
          <template v-if="productPackage.name !== 'Vĩnh Viễn'">
            từ ngày
            <span v-if="dataAppendix.dateEffectiveFrom">
              {{ dataAppendix.dateEffectiveFrom | formatDate }} đến ngày
              {{ dataAppendix.dateEffectiveTo | formatDate }}
            </span>
            <span v-else-if="dataAppendix.dateCreate">
              {{ dataAppendix.dateCreate | formatDate }}
            </span>
            <span v-else-if="dataContract.dateEffectiveFrom">
              {{ dataContract.dateEffectiveFrom | formatDate }} đến ngày
              {{ dataContract.dateEffectiveTo | formatDate }}
            </span>
            <span v-else-if="dataContract.effectiveFromDTO">
              {{ dataContract.effectiveFromDTO | formatDate }} đến ngày
              {{ dataContract.effectiveToDTO | formatDate }}
            </span>
            <span v-else-if="dataAppendix.dateCreatedAppendixDTO">
              {{ dataAppendix.dateCreatedAppendixDTO | formatDate }}
            </span>
            <span v-else-if="dataAppendix.dateCreatedAppendix">
              {{ dataAppendix.dateCreatedAppendix | formatDate }}
            </span>
          </template>
        </span>
      </div>
    </div>
    <div class="mb-4">
      <div class="d-flex ml-2 my-2">
        <span class="mr-2">1.3. </span>
        <span> Danh sách các địa điểm của Bên B sử dụng Sản phẩm/ Dịch vụ của Bên A </span>
      </div>
      <div class="table-responsive">
        <table>
          <thead>
            <tr class="text-center">
              <th scope="col">STT</th>
              <th scope="col">Tên chi nhánh/Cửa hàng</th>
              <th scope="col">Địa chỉ chi nhánh/ Cửa hàng</th>
              <th scope="col">Số tài khoản sử dụng</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="table-row text-center"
              v-for="(item, index) in dataContract.merchantBusinessAreas &&
              dataContract.merchantBusinessAreas.length > 0
                ? dataContract.merchantBusinessAreas
                : customerInfo.merchantBusinessAreas"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>
                {{ item.areaName }}
              </td>
              <td>
                {{ item.areaAddress }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Loyalty from '../table/Loyalty.vue'
  import Megadoc from '../table/Megadoc.vue'
  import MySpa from '../table/MySpa.vue'
  import NextAcc from '../table/NextAcc.vue'
  import NextHR from '../table/NextHR.vue'
  import NextPhar from '../table/NextPhar.vue'
  import NextShop from '../table/NextShop.vue'
  import PosApp from '../table/PosApp.vue'
  import VInvoice from '../table/VInvoice.vue'

  import { SalesManagerService } from '@/services/sales-manager.service'

  export default {
    props: [
      'dataContract',
      'dataAppendix',
      'title',
      'softwarePackage',
      'productPackage',
      'customerInfo',
    ],
    components: {
      Loyalty,
      Megadoc,
      MySpa,
      NextAcc,
      NextHR,
      NextPhar,
      NextShop,
      PosApp,
      VInvoice,
    },
    data() {
      return {
        dataTable: null,
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          if (this.$route.query.token) {
            const response = await SalesManagerService.getDataTablePLPM({
              serviceType: this.dataContract.serviceTypes ? this.dataContract.serviceTypes[0] : '',
              token: this.$route.query.token,
            })
            this.dataTable = response.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped src="@/pages/contract/review/css/style-review.css"></style>
